import { useState, useEffect, useContext, createContext } from "react"
import { onAuthStateChanged } from "@firebase/auth"
import { auth } from "./firebase"
import { type User } from "../types"

export const AuthContext = createContext<{ user: User }>({
  user: { loading: true },
})

export const AuthContextProvider = (props: object): any => {
  const [user, setUser] = useState({
    loading: true,
  })

  const updateUser = (loggedInUser: any): void => {
    console.info("Load Complete", loggedInUser)
    setUser({ loading: false, ...loggedInUser })
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, updateUser)
    return () => {
      unsubscribe()
    }
  }, [])

  return <AuthContext.Provider value={{ user }} {...props} />
}

export const useAuthState = (): {
  user: User
  isAuthenticated: boolean
  loading: boolean
} => {
  const auth = useContext(AuthContext)
  return {
    ...auth,
    isAuthenticated: !!auth.user.uid,
    loading: Boolean(auth.user.loading),
  }
}
